// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PtQn","comment":"styles_comment__P_Uxm"};